import {
  IUserDatastore,
  UserDto,
  userQueryExpand,
  userQueryType
} from "dev-center-lib";

import { prepareUrl, request } from "../common/apiClient";

import config from "../config.json";

export class UserDatastoreRestClient implements IUserDatastore {
  public addAsync(userDto: UserDto) {
    return new Promise<UserDto>(async (resolve, reject) => {
      try {
        const newUserDto = await request<UserDto>(
          prepareUrl(`${config.apiServer}/administrators/users`),
          {
            body: userDto,
            method: "POST"
          }
        );

        resolve(new UserDto(newUserDto));
      } catch (error) {
        reject(error);
      }
    });
  }

  public findAsync(query: userQueryType) {
    return new Promise<{
      dtos: UserDto[],
      objectsPerPage: number,
      pageNumber: number,
      totalObjectCount: number,
      totalPageCount: number
    }>(
      async (resolve, reject) => {
        try {
          const response = await request<{
            dtos: UserDto[],
            objectsPerPage: number,
            pageNumber: number,
            totalObjectCount: number,
            totalPageCount: number
          }>(
            prepareUrl(
              `${config.apiServer}/administrators/users`,
              query
            )
          );

          response.dtos = response.dtos.map((dto) => (new UserDto(dto)));
          resolve({ ...response });
        } catch (error) {
          reject(error);
        }
      }
    );
  }

  public getAsync(id: number, expand?: userQueryExpand) {
    return new Promise<UserDto>(async (resolve, reject) => {
      try {
        const userDto = await request<UserDto>(
          prepareUrl(
            `${config.apiServer}/administrators/users/${id}`,
            { expand }
          )
        );
        resolve(new UserDto(userDto));
      } catch (error) {
        reject(error);
      }
    });
  }

  public removeAsync(id: number) {
    return new Promise<void>(async (resolve, reject) => {
      try {
        await request(
          prepareUrl(
            `${config.apiServer}/administrators/users/${id}`
          ),
          { method: "DELETE" }
        );

        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  public updateAsync(userDto: UserDto) {
    return new Promise<UserDto>(async (resolve, reject) => {
      try {
        const updatedUserDto = await request<UserDto>(
          prepareUrl(
            `${config.apiServer}/administrators/users/${userDto.id}`
          ),
          {
            body: userDto,
            method: "PATCH"
          }
        );

        resolve(new UserDto(updatedUserDto));
      } catch (error) {
        reject(error);
      }
    });
  }
}
